import React from 'react';

const PermissionDenied = () =>
  <div>
    <h1 className="gap-bottom-large">Permission Denied</h1>
    <p>You need to give access your microphone :(</p>
  </div>;

export default PermissionDenied;
